(() => {
 const reduced=matchMedia('(prefers-reduced-motion:reduce)'),mobile=matchMedia('(max-width:640px)');
 const states=new WeakMap(),images=new WeakMap();
 // Animate a light surface separately; never clip/repaint the image-filled dialog.
 const motion={enter:380,mobileEnter:400,exit:260,easing:'ease-out'};
 const motifs={
  dolls:'<circle cx="52" cy="51" r="31"/><path d="M23 42h58M23 49h58M52 67v15"/><circle cx="52" cy="62" r="5"/><path d="m117 26 3 8 8 3-8 3-3 8-3-8-8-3 8-3z"/>',
  charms:'<path d="M46 50C11 15 14 80 46 59c-13 41 43 25 10-4 39 8 28-43-2-13C51 5 13 27 46 50Z"/><circle cx="49" cy="52" r="6"/><path d="M49 60v38m0-12c19-17 29-8 0 4"/><circle cx="116" cy="27" r="11"/><path d="m116 38-8 16"/>',
  hair:'<path d="M70 55C-5-6 2 105 62 61M78 55c75-61 68 50 8 6M64 51h18v17H64zM65 67l-18 38 20-7 10 9 1-37M81 68l22 34 7-17 18 3-39-25"/><path d="M18 15h7m-3-4v8"/>',
  bags:'<path d="M28 42h83l8 68H20zM48 43V31a22 22 0 0 1 44 0v12M31 54l-5 44h86l-5-44" stroke-dasharray="4 5"/><path d="M60 65c-23-15-24 18-2 11-8 23 24 22 15 0 23 7 23-26 2-13-3-21-27-20-15 2Z"/>',
  plush:'<path d="M26 76c-35-3-22-41 4-33 1-34 52-38 61-5 32-10 48 34 14 38Z"/><path d="m116 10 4 10 11 4-11 4-4 10-4-10-11-4 11-4zM27 106h8m-4-4v8"/>'
 };
 const icons=key=>`<svg viewBox="0 0 150 125" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${motifs[key]||motifs.charms}</svg>`;
 function decorate(dialog,category){
  dialog.dataset.theme=category;
  const pane=dialog.querySelector('.sheet-portrait,.new-portrait,.browser-head');
  if(!pane)return;
  let decor=pane.querySelector('.category-decoration');
  if(!decor){decor=document.createElement('div');decor.className='category-decoration';decor.setAttribute('aria-hidden','true');pane.prepend(decor)}
  decor.innerHTML=icons(category);
 }
 function triggerPose(dialog,trigger){
  const r=dialog.getBoundingClientRect(),t=trigger?.getBoundingClientRect();
  if(!t||!t.width||!t.height||t.bottom<0||t.top>innerHeight)return null;
  return `translate(${t.left+t.width/2-r.left-r.width/2}px,${t.top+t.height/2-r.top-r.height/2}px) scale(${Math.min(t.width/r.width,1)},${Math.min(t.height/r.height,1)})`;
 }
 function clearSurface(s){s.surfaceAnimation?.cancel();s.surface?.remove();s.surface=null}
 function surface(dialog,s,exit=false){
  if(!s.origin||!HTMLElement.prototype.showPopover)return;
  const r=dialog.getBoundingClientRect(),el=document.createElement('div');
  el.className='modal-flight-surface';el.setAttribute('popover','manual');el.setAttribute('aria-hidden','true');
  Object.assign(el.style,{left:r.left+'px',top:r.top+'px',width:r.width+'px',height:r.height+'px',background:getComputedStyle(dialog).getPropertyValue('--modal-tint')});
  document.body.append(el);el.showPopover();s.surface=el;
  const duration=exit?motion.exit:mobile.matches?motion.mobileEnter:motion.enter;
  s.surfaceAnimation=el.animate(exit?
   [{transform:'none',opacity:0},{transform:s.origin,opacity:.6,offset:.85},{transform:s.origin,opacity:0}]:
   [{transform:s.origin,opacity:.75},{transform:'none',opacity:0}],
   {duration,easing:motion.easing});
  s.surfaceAnimation.finished.then(()=>{el.remove();if(s.surface===el)s.surface=null}).catch(()=>{});
 }
 const visiblePose={opacity:1,transform:'none'};
 function open(dialog,trigger,instant=false){
  let s=states.get(dialog)||{animation:null,version:0,parent:null};
  const wasOpen=dialog.open,style=wasOpen?getComputedStyle(dialog):null;
  let start=wasOpen?{opacity:style.opacity,transform:style.transform}:null;
  s.version++;s.closing=false;s.animation?.cancel();clearSurface(s);s.trigger=trigger;states.set(dialog,s);
  if(!wasOpen){s.parent=[...document.querySelectorAll('dialog[open]')].at(-1)||null;dialog.dataset.nested=String(!!s.parent);dialog.showModal();dialog.scrollTop=0}
  if(!wasOpen){s.origin=triggerPose(dialog,trigger);start={opacity:0,transform:'translateY(12px) scale(.985)'}}
  s.parent?.classList.add('modal-covered');
  document.documentElement.style.overflow='hidden';
  dialog.classList.add('modal-open');
  dialog.classList.toggle('modal-instant',instant||reduced.matches);
  dialog.querySelector('.close,.new-close,.browser-close')?.focus({preventScroll:true});
  if(instant||reduced.matches)return;
  if(!wasOpen)surface(dialog,s);
  s.animation=dialog.animate([start,visiblePose],{duration:280,delay:wasOpen?0:80,fill:'backwards',easing:motion.easing});
 }
 async function close(dialog,trigger,instant=false){
  if(!dialog.open)return;
  let s=states.get(dialog);if(!s||s.closing)return;
  // Capture input intent before the exit animation/history callback completes.
  const touchReturn=mobile.matches&&document.documentElement.dataset.dhInput==='pointer';
  s.closing=true;const version=++s.version,style=getComputedStyle(dialog),start={opacity:style.opacity,transform:style.transform};s.animation?.cancel();clearSurface(s);
  dialog.classList.toggle('modal-instant',instant||reduced.matches);dialog.classList.remove('modal-open');
  s.parent?.classList.remove('modal-covered');
  if(!instant&&!reduced.matches){
   surface(dialog,s,true);
   s.animation=dialog.animate([start,{opacity:0,transform:'translateY(10px) scale(.985)'}],{duration:motion.exit,easing:motion.easing,fill:'forwards'});try{await s.animation.finished}catch{}
  }
  if(s.version!==version)return;
  const returnTarget=trigger||s.trigger;
  if(touchReturn)returnTarget?.setAttribute('data-dh-pointer-focus','');
  dialog.close();s.animation?.cancel();clearSurface(s);s.animation=null;s.closing=false;
  if(!document.querySelector('dialog[open]'))document.documentElement.style.overflow='';
  // Keep the return position for keyboard/assistive navigation. The explicit
  // pointer marker also covers WebKit's inherited :focus-visible state.
  returnTarget?.focus({preventScroll:true,...(touchReturn?{focusVisible:false}:{})});
 }
 async function swapImage(img,src,alt,instant=false){
  // Each request owns its image. Never retain the previous product while decoding.
  const old=images.get(img);old?.animation?.cancel();
  const state={animation:null};images.set(img,state);
  img.style.visibility='hidden';img.style.opacity='1';img.alt=alt||'';
  img.removeAttribute('srcset');img.removeAttribute('sizes');img.removeAttribute('src');
  img.removeAttribute('data-image-error');
  if(!src){img.removeAttribute('aria-busy');return false}
  img.setAttribute('aria-busy','true');img.src=src;
  try{await img.decode()}catch{
   if(images.get(img)!==state)return false;
   img.removeAttribute('aria-busy');img.setAttribute('data-image-error','');return false;
  }
  if(images.get(img)!==state)return false;
  img.removeAttribute('aria-busy');img.style.visibility='visible';
  if(!instant&&!reduced.matches&&img.closest('dialog')?.open)state.animation=img.animate([{opacity:0},{opacity:1}],{duration:120,easing:'ease-out'});
  return true;
 }

 window.dollopModal={open,close,decorate,swapImage};
})();
